<template>
  <medal-bronze v-if="type=='bronze'"/>
  <medal-silver v-else-if="type=='silver'"/>
  <medal-gold v-else-if="type=='gold'"/>
  <div v-else/>
</template>

<script>
import MedalBronze from "@/components/MedalBronze";
import MedalSilver from "@/components/MedalSilver";
import MedalGold from "@/components/MedalGold";
export default {
  name: "Medal",
  components: {MedalBronze,MedalSilver,MedalGold},
  props: ['type'], // bronze | silver | gold

}
</script>

<style scoped>

</style>